module.exports = __webpack_public_path__ + "img/008-download.0ba564e4.png";